import { render, staticRenderFns } from "./TripFilters.vue?vue&type=template&id=38a00b76&scoped=true&"
import script from "./TripFilters.vue?vue&type=script&lang=js&"
export * from "./TripFilters.vue?vue&type=script&lang=js&"
import style0 from "./TripFilters.vue?vue&type=style&index=0&id=38a00b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a00b76",
  null
  
)

/* custom blocks */
import block0 from "./TripFilters.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports